module.exports = {
  API_URl: `${process.env.REACT_APP_API_URL}`,
  SITE_KEY: `${process.env.REACT_APP_SITE_KEY}`,
  // API_URl: `http://localhost:4000/api/hmt`, for local
};
